import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

// import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

// import RightArrow from '../../assets/images/right-arrow.png';

export default function ElitepropertyManagmentServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Elite Property Management</title>
        <meta
          name='description'
          content='Our property management team brings white-glove service to every community. We focus on tenant satisfaction, operational efficiency, and financial transparency—protecting and growing the value of your asset.'
        />
        <meta
          name='keywords'
          content='Elite Property Management, White-Glove Service, Tenant Satisfaction, Operational Efficiency, Financial Transparency'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>Elite Property Management</h2>
        <p className='service-page-text'>
          Our property management team brings white-glove service to every
          community. We focus on tenant satisfaction, operational efficiency,
          and financial transparency—protecting and growing the value of your
          asset.
        </p>
      </div>
      {/* <div className='our-services-section'>
        <h2 className='section-title'>Services</h2>
        <div className='service-list'>
          <Link
            to={ROUTE_NAMES.CAPITALVENTURES}
            className='service-block green-block'
          >
            <h3>Capital Ventures</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link to={ROUTE_NAMES.LENDINGSOLUTIONS} className='service-block'>
            <h3>Lending Solutions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.EBSERVICE}
            className='service-block green-block'
          >
            <h3>EB-5 & Foreign Capital Consulting</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div> */}
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
